import { GetStaticPaths, GetStaticProps } from 'next'
import { ReactElement } from 'react'

import { dehydrate, QueryClient } from 'react-query'

import { getCategories } from 'app/services/Api/listing'
import { listingConfig } from 'app/services/Query/listing/listing.query'
import { vehicleConfig } from 'app/services/Query/vehicle/vehicle.query'
import { NextPageExtended } from 'app/types/interfaces/nextjs'

import MainLayout from '~/components/layouts/MainLayout/MainLayout'
import CategoryView from '~/views/CategoryView'

const CategoryPage: NextPageExtended = () => {
  return <CategoryView />
}

CategoryPage.getLayout = (page: ReactElement) => <MainLayout>{page}</MainLayout>

export const getStaticPaths: GetStaticPaths = async () => {
  const categories = await getCategories()

  const paths = categories.reduce(
    (acc, path) => acc.concat([{ params: { category: String(path.slug) } }]),
    [] as { params: { category?: string } }[]
  )

  return { paths, fallback: false }
}

export const getStaticProps: GetStaticProps = async (context) => {
  const category = context.params?.category as string

  try {
    const queryClient = new QueryClient()

    await queryClient.prefetchQuery(
      listingConfig.getListingCategories.key,
      listingConfig.getListingCategories.request
    )

    await queryClient.prefetchQuery(
      vehicleConfig.getVehicleUniversalParams.key,
      vehicleConfig.getVehicleUniversalParams.request
    )

    const categoriesState = queryClient.getQueryState<Category[]>(
      listingConfig.getListingCategories.key
    )

    const currentCategoryId = categoriesState?.data?.find(
      (item) => String(item.slug) === category
    )?.id

    if (!currentCategoryId) throw new Error('Category not found')

    return { props: { dehydratedState: dehydrate(queryClient) } }
  } catch (error) {
    return { notFound: true }
  }
}

export default CategoryPage
